export const FETCH_QUIZ_ASSOCIATION_OPTIONS_REQUEST = '@quiz/FETCH_QUIZ_ASSOCIATION_OPTIONS_REQUEST';
export const FETCH_QUIZ_ASSOCIATION_OPTIONS_SUCCESS = '@quiz/FETCH_QUIZ_ASSOCIATION_OPTIONS_SUCCESS';
export const FETCH_QUIZ_ASSOCIATION_OPTIONS_FAILED = '@quiz/FETCH_QUIZ_ASSOCIATION_OPTIONS_FAILED';
